<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eUYoQ7/tc-custom/9781504094412.jpg?1716663164299" alt="This image is the cover for the book Car Share"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Car Share
      </h1>
      <p class="bookDescription body article font2">
        <b>Embark on a heart-warming romantic journey in this delightful comedy that proves it doesn’t matter where you’re going—it’s who you have beside you on the way . . .</b><br/><br/> After Lia’s old car breathes its last, the single mom must reluctantly take the bus to work . . . and face unwarranted attention from a troublesome teenager. It’s all too much to take—she’s been depressed since her fiancé’s death and even quit her beloved women’s football team. But it’s Happy Car Sharers to the rescue after her friends get her set up on the app.<br/><br/> Mateo, meanwhile, has recently moved to town, and his long walk to the train station is a literal pain due to an ankle injury. Soon he and Lia are riding each morning with a charmingly bossy driver and a rotation of colorful fellow passengers.<br/><br/> It’s not love at first sight. Technically it’s not even first sight: they’ve seen each other before at the nursing home where both their fathers live and Mateo plays piano for the residents. But with each trip they get to know each other better . . . and the more they know, the more they find to like.<br/><br/> With both of them consumed by personal losses and pressing family responsibilities—and another man getting in the way—can romance lie on the road ahead for these commuting companions?<br/><br/><i>The Car Share</i> is a humorous exploration of love, loss, and the unexpected detours that lead us to where we truly belong.<br/><br/><b>Praise for Lucy Mitchell</b><br/><br/> “[Mitchell’s] writing is deliciously funny and has so much heart.” —Sandy Barker, author of <i>One Summer in Santorini</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lucy Mitchell
      </h2>
      
      <p class="authorDescription body article">Lucy Mitchell lives in Monmouthshire, South Wales, with her husband, two teenage daughters, three unruly cats and one very excitable Labrador. She&#39;s been writing seriously ever since&#160;her husband paid for her to go on a creative writing course back in 2014. Following this she decided to launch her writer blog where she shared funny stories from her own writing experiences. After winning the award for &#39;Funniest Blog&#39; in an annual blogging competition for two years running, she set about writing romantic comedy&#160;novels. She self published her first novel in 2019.&#160;<BR /> &#160;<BR /> Lucy has three passions in life; writing romance, reading romance and showing off her colour coded bookshelves on social media. When she&#39;s not writing Lucy can either be found walking her dog or tucking into scampi and chips&#160;in her favourite local pub.&#160;<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?652da166